import React from 'react';

import { Button, Modal } from '@unimed-fesp/components';

import { FaDoorOpen } from 'react-icons/fa';
import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';

import theme from '../../../styles/theme';

import { Container, ContentText, TextSucesso } from './styles';

function ModalLogout({ isOpen, onClick, logOut }) {
  return (
    <Modal
      isOpen={isOpen}
      onClick={onClick}
      height={345}
      width={460}
      footer={<ModalFooter onClick={onClick} logOut={logOut} />}
    >
      <ModalContentWrapper>
        <ModalContent>
          <Container>
            <FaDoorOpen color={theme.greenDefault} size="100" />
            <TextSucesso text="log out" />
            <ContentText>Você deseja sair do sistema?</ContentText>
          </Container>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}

const ModalFooter = ({ onClick, logOut }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        color={theme.greenDefault}
        marginRight={10}
        width={100}
        alignCenter
        justifyCenter
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        onClick={logOut}
        color={theme.bgWhite}
        marginLeft={10}
        width={100}
        alignCenter
        justifyCenter
      >
        sair
      </Button>
    </>
  );
};

export default ModalLogout;
